import React from 'react';

import { ResearchCompactPreview } from './ResearchCompactPreview';

export const SingleResearchCompactPreview = (
	props: React.ComponentProps<typeof ResearchCompactPreview>,
): JSX.Element => <ResearchCompactPreview {...props} />;
